// LIST
export const FETCH_CONTENT = "app/FOLDER/FETCH_CONTENT";
export const FETCH_CONTENT_SUCCESS = "app/FOLDER/FETCH_CONTENT_SUCCESS";
export const FETCH_CONTENT_FAILURE = "app/FOLDER/FETCH_CONTENT_FAILURE";

export const UPDATE_CONTENT_FOLDERS = "app/FOLDER/UPDATE_CONTENT_FOLDERS";
export const UPDATE_CONTENT_FILES = "app/FOLDER/UPDATE_CONTENT_FILES";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/FOLDER/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/FOLDER/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/FOLDER/GET_VIEW_DATA_FAILURE";

// ADD
export const ADD_FOLDER = "app/FOLDER/ADD_FOLDER";
export const ADD_FOLDER_SUCCESS = "app/FOLDER/ADD_FOLDER_SUCCESS";
export const ADD_FOLDER_FAILURE = "app/FOLDER/ADD_FOLDER_FAILURE";

// EDIT
export const EDIT_FOLDER = "app/FOLDER/EDIT_FOLDER";
export const EDIT_FOLDER_SUCCESS = "app/FOLDER/EDIT_FOLDER_SUCCESS";
export const EDIT_FOLDER_FAILURE = "app/FOLDER/EDIT_FOLDER_FAILURE";

// DELETE
export const DELETE_FOLDER = "app/FOLDER/DELETE_FOLDER";
export const DELETE_FOLDER_SUCCESS = "app/FOLDER/DELETE_FOLDER_SUCCESS";
export const DELETE_FOLDER_FAILURE = "app/FOLDER/DELETE_FOLDER_FAILURE";

export const UPLOAD_FILE = "app/FOLDER/UPLOAD_FILE";
export const UPLOAD_FILE_SUCCESS = "app/FOLDER/UPLOAD_FILE_SUCCESS";
export const UPLOAD_FILE_FAILURE = "app/FOLDER/UPLOAD_FILE_FAILURE";

export const VALIDATE_FILE = "app/FOLDER/VALIDATE_FILE";
export const VALIDATE_FILE_SUCCESS = "app/FOLDER/VALIDATE_FILE_SUCCESS";
export const VALIDATE_FILE_FAILURE = "app/FOLDER/VALIDATE_FILE_FAILURE";
